import React from 'react';
import Select from 'react-select';
import { customDarkSelectStyles } from './CustomDarkSelectStyles'

const CustomSelect = ({ placeholder, styles, options, selectedOption, onOptionChange }) => {
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      width: '200px',
      zIndex: "200"
    }),
  };

  const customOption = ({ innerProps, label, value, isFocused }) => (
    <div {...innerProps}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 10px',
        backgroundColor: isFocused ? '#3a3a3a' : '#2c2c2c',
        color: '#f1f1f1',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease-in-out',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#4a4a4a')}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = isFocused ? '#3a3a3a' : '#2c2c2c')}
    >
      {label}
    </div>
  );



  return (
    <Select
      hideSelectedOptions={selectedOption.length < 3 ? true : false}
      isMulti
      options={options}
      onChange={(selectedOptions) => onOptionChange(selectedOptions)}
      value={selectedOption}
      components={{ Option: customOption }}
      styles={customDarkSelectStyles}
      placeholder={placeholder}
    />
  );
};

export default CustomSelect;
